
export const COMMENT_SHOW_LENGTH = 500;
export const TASK_DESCRIPTION_LENGTH = 120;
export const COMMENT_REPLY_LIMIT = 3;
export const REPLY_TEXT_LENGTH = 100;
export const MAX_DEVELOPMENT_EFFORT: number = 2;